import React, { useCallback, useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { BpaContext, IBpaContext } from '../bpaState/bpaContext';
import { useGoBack } from 'hooks/useGoBack';
import { convertUndefinedFields } from 'utils/helpers';
import { updateCustomerBPA } from 'backend/customers';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirmNew } from 'components/ModalWindows/ModalToConfirmNew';
import { ModalSentSuccessfullyNew } from 'components/ModalWindows/ModalSentSuccessfullyNew';
import { ModalSentErrorNew } from 'components/ModalWindows/ModalSentErrorNew';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, refetchData, dataForSubmit, typeOfModalWindow } =
		useContext<IBpaContext>(BpaContext);
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/clients/customers-new-ui');
	}, [goBack]);

	const handleSubmit = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateCustomerBPA(convertedData);
				changeTypeOfModalWindow('success');
			} catch {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [changeTypeOfModalWindow, showLoader, hideLoader, dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleUpdateData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, [refetchData, changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirmNew
					onConsentEvent={handleRedirect}
					onFailureEvent={handleCloseModal}
					description="cancelSaveInfo"
					typeOfInfoIcon="toSave"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirmNew
					onConsentEvent={handleSubmit}
					onFailureEvent={handleCloseModal}
					description="saveInfo"
					typeOfInfoIcon="toSave"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfullyNew onConsentEvent={handleUpdateData} description="savedSuccessfully" />
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="errorWhileSaving" />
			)}
		</ModalWrapper>
	);
};
